import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { updateUserInfo } from "../../redux/action";
import { getProfileInformation } from "../../services";
import Sidebar from "../Sidebar";
import "./style.scss";

const AppLayout = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    getProfileInformation().then((response) => {
      const { data } = response;
      dispatch(updateUserInfo({ ...data }));
    });
  }, [dispatch]);
  return (
    <div className="row w-100">
      <div className="col-md-3 d-none d-md-flex">
        <Sidebar />
      </div>
      <div className="col">
        <div className="p-4 page-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
